// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IOfflinePageProps {
  // TODO
}

const OfflinePage: React.FunctionComponent<IOfflinePageProps> = () => {
  return <div>Offline</div>;
};

export default OfflinePage;
